import React from 'react';
import {useParams} from 'react-router-dom';
import {useMediaQuery, useTheme} from '@mui/material';

import TopAppBar from '../../common/top-app-bar/TopAppBar';
import PadsMenuList from './pads-menu-list/PadsMenuList';

import {
  ContentDiv,
  ContentGrid,
  ContentGridDiv,
  MenuHomePageWrapperGrid,
  MainContentDiv,
  MainContentGrid,
  TopAppBarDiv,
  BackgroundGrid
} from './PadsHomePageStyles';
import CreatePadOptionsScreen from '@components/create-pad/CreatePadOptionsScreen';
import PadViewPage from './pads-view-page/PadViewPage';

const PadsHomePage = (): React.ReactElement => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const params: any = useParams();
  const [drawer, setDrawer] = React.useState<boolean>(true);
  const [showPadOptionsPage, setShowPadOptionsPage] =
    React.useState<boolean>(false);

  const handleMenuAction = () => {
    setDrawer(!drawer);
  };

  const handlePadCreateAction = () => {
    setShowPadOptionsPage(true);
  };

  return (
    <MenuHomePageWrapperGrid container>
      <BackgroundGrid>
        <ContentGrid item>
          <ContentGridDiv>
            {!isMobile && (
              <PadsMenuList
                padId={params?.pad_id}
                drawerOpen={drawer}
                applicationId={params?.application_id}
              />
            )}

            <ContentDiv>
              <TopAppBarDiv>
                <TopAppBar
                  handleMenuAction={() => handleMenuAction()}
                  showEditPadButton={true}
                  showAddPadButton={true}
                  handleAddPadAction={() => handlePadCreateAction()}
                  applicationId={params?.application_id}
                  padId={params?.pad_id}
                />
              </TopAppBarDiv>

              <MainContentDiv>
                <MainContentGrid item>
                  {showPadOptionsPage ? (
                    <CreatePadOptionsScreen />
                  ) : (
                    <PadViewPage
                      applicationId={params?.application_id}
                      action={() => handlePadCreateAction()}
                    />
                  )}
                </MainContentGrid>
              </MainContentDiv>
            </ContentDiv>
          </ContentGridDiv>
        </ContentGrid>
      </BackgroundGrid>
    </MenuHomePageWrapperGrid>
  );
};
export default PadsHomePage;
